import { Input, Select } from 'antd';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';

import { SettingsConfigType } from 'src/features/tenants/types/tenantForm.types';

export interface SettingsConfigInputProps {
  field: ControllerRenderProps<
    FieldValues,
    `settings.edit.${number}.configValue` | `settings.add.${number}.configValue`
  >;
}

export const configTypeComponetsByType = {
  [SettingsConfigType.String]: ({ field }: SettingsConfigInputProps) => (
    <Input {...field} placeholder='Insira um valor...' type='string' />
  ),
  [SettingsConfigType.Number]: ({ field }: SettingsConfigInputProps) => (
    <Input {...field} placeholder='Insira um valor...' type='number' />
  ),
  [SettingsConfigType.Boolean]: ({ field }: SettingsConfigInputProps) => (
    <Select
      {...field}
      placeholder='Selecione um valor...'
      options={[
        { label: 'Verdadeiro', value: 'true' },
        { label: 'Falso', value: 'false' },
      ]}
    />
  ),
};
